import { render, staticRenderFns } from "./Skypark.vue?vue&type=template&id=5dd6d7e4&"
import script from "./Skypark.vue?vue&type=script&lang=js&"
export * from "./Skypark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable,QTd})
